export default {"src":"/_next/static/media/facebook.f4f7aaca.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};